import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.ResidentialProxy
const label = visitFilterLabelMap[key]

export const residentialProxyColumn = () =>
  columnHelper.display({
    id: 'residentialProxy',
    header: 'Residential Proxy',
    cell: ({ row }) => {
      const result = row.original.proxy

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
